import { IConnector } from '../connectors/IConnector';
let _connector: IConnector;

export function getConnector(): IConnector {
    return _connector;
}

export function setConnector(connector: IConnector): void {
    _connector = connector;
}
